export default {
	setLogin(state, payload) {
	  if(payload && !payload.loginTime){
      payload.loginTime = Date.now();
    }
		localStorage.setItem('login', JSON.stringify(payload));
		state.login = payload;
	},
	setLoading(state, payload) {
		state.loading = payload;
	},
	clearLogin(state, payload) {
		localStorage.setItem('login', null);
	},
	setUnauthorized(state, payload) {
		state.unauthorized = payload;
	},
	setErrBlock(state, payload) {
		state.showErrBlock = payload;
	},
	setSessionExpired(state, payload) {
		state.sessionExpired = payload;
	},
	setType(state, payload) {
    localStorage.setItem('type', JSON.stringify(payload));
		state.type = payload;
	},
  setPrevType(state, payload) {
    localStorage.setItem('prevType', JSON.stringify(payload));
    state.prevType = payload;
  },
  setVisitorId(state, payload) {
    localStorage.setItem('visitorId', JSON.stringify(payload));
    state.visitorId = payload;
  },
  setPrevPage(state, payload) {
    state.prevPage = payload;
  },
  setFromPath(state, payload) {
    localStorage.setItem('from_path', JSON.stringify(payload));
    state.fromPath = payload;
  },
  setPrevPath(state, payload) {
    state.prevPath = payload;
  },
  setDisqualified(state, payload) {
    state.disqualified = payload;
  },
  setAddGroups(state, payload) {
    state.addGroups = payload;
  },
  setSuccessMessage(state, payload) {
    state.successMessage = payload;
  },
  setAlertMessage(state, payload) {
    state.alertMessage = payload;
  },
  setFormID(state, payload) {
    localStorage.setItem('formID', JSON.stringify(payload));
    state.formID = payload;
  },
  setDocuments(state, payload) {
    state.documents = payload;
  },
  addDocument(state, payload) {
    state.documents.push(payload);
  },
}
